export default "__VITE_ASSET__5nBARsOW__"